import React from "react";
import { getTranslation } from "./utils";
import { pageLang } from "./App";

export default {
  items: [
    {
      title: true,
      name: "PIM",
      wrapper: {
        element: "",
        attributes: {},
      },
      class: "",
    },

    {
      name: getTranslation("products", pageLang),
      url: "/pim/products",
      icon: "icon-grid",
    },

    {
      name: getTranslation("translations", pageLang),
      url: "/pim/product-translation",
      icon: "cui-speech",
    },
    {
      name: getTranslation("pictures", pageLang),
      url: "/pim/product-pictures",
      icon: "icon-handbag",
    },
    {
      name: getTranslation("bulkUpload", pageLang),
      url: "/pim/multi-upload",
      icon: "icon-cloud-upload",
    },
    {
      name: getTranslation("channelsAssortment", pageLang),
      url: "/pim/product-assortments",
      icon: "cui-cart",
    },
    {
      name: getTranslation("parameterSets", pageLang),
      url: "/pim/product-parameters",
      icon: "icon-list",
    },
    {
      name: getTranslation("settings", pageLang),
      url: "/pim/settings",
      icon: "icon-settings",
    },

    {
      name: getTranslation("reorderPoints", pageLang),
      url: "/pim/franchise-reorder",
      icon: "icon-settings",
    },

    // {
    //   name: getTranslation("Price Check Tool", pageLang),
    //   url: "/pim/price-check",
    //   icon: "fa fa-money",
    // },

    {
      title: true,
      name: getTranslation("exports", pageLang),
      wrapper: {
        element: "",
        attributes: {},
      },
      class: "",
    },

    {
      name: getTranslation("productExport", pageLang),
      url: "/export/product-export",
      icon: "icon-share-alt",
    },

    {
      name: getTranslation("assortmentProductsExport", pageLang),
      url: "/export/assortment-export",
      icon: "icon-share-alt",
    },
    {
      name: getTranslation("matrixProductExport", pageLang),
      url: "/export/matrix-product-export",
      icon: "icon-share-alt",
    },

    {
      title: true,
      name: getTranslation("classifiers", pageLang),
      wrapper: {
        element: "",
        attributes: {},
      },
      class: "",
    },
    {
      name: getTranslation("brands", pageLang),
      url: "/classifiers/brands",
      icon: "cui-briefcase",
    },

    {
      name: getTranslation("countries", pageLang),
      url: "/classifiers/countries",
      icon: "icon-globe",
    },

    {
      name: getTranslation("extraField1", pageLang),
      url: "/classifiers/extra-field1",
      icon: " icon-options",
    },
    {
      name: getTranslation("extraField2", pageLang),
      url: "/classifiers/extra-field2",
      icon: " icon-options",
    },
    {
      name: getTranslation("extraField3", pageLang),
      url: "/classifiers/extra-field3",
      icon: " icon-options",
    },
    {
      name: getTranslation("extraField4", pageLang),
      url: "/classifiers/extra-field4",
      icon: " icon-options",
    },

    {
      name: getTranslation("matDimesions", pageLang),
      url: "/classifiers/matrix-dimensions",
      icon: "icon-equalizer",
    },

    {
      name: getTranslation("productCategories", pageLang),
      url: "/classifiers/product-categories",
      icon: "cui-calendar",
    },

    {
      name: getTranslation("productFamilies", pageLang),
      url: "/classifiers/product-families",
      icon: "icon-people",
    },

    {
      name: getTranslation("priorityGroups", pageLang),
      url: "/classifiers/priority-groups",
      icon: "fa fa-group",
    },

    {
      name: getTranslation("productGroups", pageLang),
      url: "/classifiers/product-groups",
      icon: "icon-layers",
    },
    {
      name: getTranslation("suppliers", pageLang),
      url: "/classifiers/suppliers",
      icon: "icon-user",
    },
    {
      name: getTranslation("units", pageLang),
      url: "/classifiers/units",
      icon: "icon-compass",
    },
  ],
};
